import React from 'react';
import { Typography, Grid } from '@material-ui/core';
import { formatTimestamp } from '../../utils/formatters';
import { VersionCard } from './VersionCard';

interface MLModelVersionsProps {
  versions: any[];
}

export const MLModelVersions = ({ versions }: MLModelVersionsProps) => {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Versions
      </Typography>
      <Grid container spacing={2}>
        {versions.map((v: any) => (
          <Grid
            item
            xs={12}
            sm={6}
            md={4}
            key={v.version}
            style={{ display: 'flex' }}
          >
            <VersionCard version={v} formatTimestamp={formatTimestamp} />
          </Grid>
        ))}
      </Grid>
    </>
  );
};
